export default "__VITE_ASSET__Da83ndCQ__"